import React from 'react';
import {
  Check,
  Star,
  ExternalLink,
  Calendar,
  Clock,
  TrendingUp,
  Target,
  Trash2,
} from 'lucide-react';

const ProblemCard = ({ question, onToggleAttempted, onToggleStar, onDelete }) => {
  return (
    <div className="problem-card">
      <div className="problem-card-content">
        <div className="problem-card-actions">
          <button
            onClick={() => onToggleAttempted(question.id)}
            className={`action-btn ${
              question.attempted ? 'action-btn-attempted' : ''
            }`}
          >
            {question.attempted && <Check size={20} />}
          </button>
          <button
            onClick={() => onToggleStar(question.id)}
            className={`action-btn ${
              question.starred ? 'action-btn-starred' : ''
            }`}
          >
            <Star
              size={20}
              className={question.starred ? 'star-filled' : ''}
            />
          </button>
        </div>

        <div className="problem-card-details">
          <div className="problem-card-header">
            <div className="problem-card-title-group">
              <h3 className="problem-card-title">{question.title}</h3>
              {question.problemUrl && (
                <a
                  href={question.problemUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="problem-link"
                >
                  <ExternalLink size={18} />
                </a>
              )}
            </div>
            <button onClick={() => onDelete(question.id)} className="delete-btn">
              <Trash2 size={18} />
            </button>
          </div>

          <div className="problem-badges">
            <span
              className={`badge badge-platform badge-${question.platform.toLowerCase()}`}
            >
              {question.platform}
            </span>
            <span
              className={`badge badge-difficulty badge-${question.difficulty.toLowerCase()}`}
            >
              {question.difficulty}
            </span>
            <span className="badge badge-algorithm">{question.algorithm}</span>
          </div>

          <div className="problem-meta">
            <div className="meta-item">
              <Calendar size={14} />
              <span>{question.date}</span>
            </div>
            {question.timeTaken && (
              <div className="meta-item">
                <Clock size={14} />
                <span>{question.timeTaken}</span>
              </div>
            )}
            {question.timeComplexity && (
              <div className="meta-item">
                <TrendingUp size={14} />
                <span>Time: {question.timeComplexity}</span>
              </div>
            )}
            {question.spaceComplexity && (
              <div className="meta-item">
                <Target size={14} />
                <span>Space: {question.spaceComplexity}</span>
              </div>
            )}
          </div>

          <div className="problem-details">
            <div className="solution-box">
              <h4 className="solution-title">💻 Solution</h4>
              <pre className="solution-code">{question.solution}</pre>
            </div>
            {question.notes && (
              <div className="notes-box">
                <h4 className="notes-title">📝 Notes</h4>
                <p className="notes-content">{question.notes}</p>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProblemCard;